var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 132,
    viewBox: "0 0 85 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 132,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1153_2894)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -727,
    width: 1512,
    height: 982,
    rx: 10,
    fill: "url(#paint0_linear_1153_2894)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.492833,
    d: "M8.82622 -29.1121C18.7378 -28.5041 28.4524 -26.0441 37.4654 -21.8549C46.9321 -17.4548 55.4394 -11.2332 62.5016 -3.54533C69.5639 4.14257 75.0427 13.1462 78.6253 22.9515C82.2079 32.7567 83.8242 43.1717 83.3818 53.6016C82.9394 64.0315 80.447 74.2721 76.0469 83.7388C71.6468 93.2055 65.4252 101.713 57.7373 108.775C50.0494 115.837 41.0458 121.316 31.2405 124.899C21.9051 128.31 12.0171 129.938 2.08968 129.705L3.09029 106.115C9.92003 106.221 16.7159 105.074 23.1395 102.727C30.0332 100.208 36.3633 96.3564 41.7683 91.3913C47.1733 86.4261 51.5474 80.445 54.641 73.7894C57.7345 67.1338 59.4868 59.934 59.7978 52.6012C60.1088 45.2684 58.9725 37.9461 56.4537 31.0524C53.9349 24.1588 50.083 17.8287 45.1179 12.4237C40.1527 7.01868 34.1716 2.64456 27.516 -0.448952C21.3141 -3.33156 14.6398 -5.04959 7.8256 -5.52211L8.82622 -29.1121Z",
    fill: "#EB5757",
    stroke: "#111111",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1153_2894",
    x1: 29,
    y1: 0,
    x2: 29,
    y2: 982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474002,
    stopColor: "#EAEDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D4E1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1153_2894"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -727,
    width: 1512,
    height: 982,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTube);
export default __webpack_public_path__ + "static/media/Tube.3c510ef12335b5b8c53180a74af732e0.svg";
export { ForwardRef as ReactComponent };